import { AppEnvironment } from '../app/models/environment/app-environment.type';
import { buildConfig } from '../configs/build/build-config';

export const environment: AppEnvironment = {
  ...buildConfig,
  name: 'dev',
  production: false,
  runtimeConfigPath: 'config.json',
  posthog: {
    key: 'phc_KqfJB7STBTMj9va89NIPScVo7bR7T81D7eVrNmgMUoy',
    host: 'https://eu.i.posthog.com',
  },
};
